import Http from '../libs/http';

export default {
  visaCourseBriefQuery() {
    return Http.post('/sys/visa_course_brief_query', {});
  },

  formatClassDate(date) {
    if (date) {
      const dateObj = new Date(date);
      const weekDay = '日一二三四五六';
      const timeStr = date.split(' ')[1].substring(0, 5);
      return `${dateObj.getMonth() + 1}月${dateObj.getDate()}日（周${weekDay.charAt(dateObj.getDay())}）${timeStr} `;
    }
    return '';
  },

  goToCourseDetail(course, from, router) {
    if (course.learn_way === 1) {
      const { href } = router.resolve({ name: 'classDetail', params: { courseId: course.course_id }, query: { from } });
      window.open(href, '_blank');
    } else {
      window.open(course.live_link);
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/visa-academy-service.js